import {
    useGetTasksTemplateSingleVoyageQuery
} from "@containers/singleVoyage/taskTemplate/queryHooks/useTaskTemplateSingleVoyageQuery";
import {useCallback} from "react";
import {ITaskTemplateSingleVoyage} from "@containers/singleVoyage/taskTemplate/types";

export function useGetTaskConfigByIdSingleVoyage({accountId}: {
    accountId: string | number
}): {
    getTaskConfigById: (id: number) => ITaskTemplateSingleVoyage | null,
    isFetching: boolean,
    isLoading: boolean

} {
    const {
        data,
        isFetching,
        isLoading
    } = useGetTasksTemplateSingleVoyageQuery({
        params: {
            accountId,
        }
    })

    const getTaskConfigById = useCallback((id: number): ITaskTemplateSingleVoyage | null => {
        if (!data?.length) {
            return null
        }
        return data.find((item) => item.id?.toString() === id?.toString())
    }, [data])

    return {
        getTaskConfigById,
        isFetching,
        isLoading
    }
}
